import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import { Dropdown, Grid, Input, Button, Form, TextArea, Select, Label, Table } from 'semantic-ui-react';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Info from './info';
import Characteristics from './characteristic';
import Branch from './branch';
import BrandImage from './brand/image';
import Brand from './brand';
import Categorisation from './categorisation';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';


const styles = {
  appBar: { position: 'relative', }, flex: { flex: 1, },
};

function Transition(props) { return <Slide direction="up" {...props} />; }

class FullScreenDialog extends React.Component {

  state = {
    value: 'one',
  };

  openDialog() {
    let partno = this.props.partno;
    let title = this.props.title;
    let error = 1;
    this.props.datas.map((c) => {
      if (partno == c.partno && title) {
        error = 0;
      }
    })
    if (error == 0) {
      this.setState({ openDialog: true })
    }
    else {
      alert('Select Partno Properly')
    }
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const { classes } = this.props;
    const { value } = this.state;
    return (
      <div>
        { this.props.edit == 'edit' ?
          (<u style={{color: 'blue'}} onClick={this.openDialog.bind(this)}><center>Edit</center></u>):
          (<Button variant="outlined" onClick={this.openDialog.bind(this)} color="inherit">GO</Button>)
        }
        <Dialog fullScreen open={this.state.openDialog}
          TransitionComponent={Transition}>
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton color="inherit" onClick={ () => { this.setState({ openDialog: false }) }} aria-label="Close">
              <CloseIcon />
              </IconButton>
              <Typography variant="h6" color="inherit" className={classes.flex}> {this.props.title} </Typography>
            </Toolbar>
          </AppBar>
          <div className={classes.root}>
            <AppBar position="static" style={{backgroundColor: 'white', color: 'black', fontWeight: 'bold'}}>
              <Tabs value={value} onChange={this.handleChange}>
                <Tab value="one" label="Info" />
                <Tab value="two" label="characteristics" />
                <Tab value="three" label="Categorisation" />
                <Tab value="four" label="Brand" />
                <Tab value="five" label="Image" />
              </Tabs>
            </AppBar>
            {value === 'one' && <Info partsedit={this.props.partsedit} partno={this.props.partno} title={this.props.title} menus={this.props.menus} />}
            {value === 'two' && <Characteristics partsedit={this.props.partsedit} partno={this.props.partno} title={this.props.title} menus={this.props.menus} />}
            {value === 'three' && <Categorisation partsedit={this.props.partsedit} partno={this.props.partno} title={this.props.title} menus={this.props.menus} />}
            {value === 'four' && <Brand partsedit={this.props.partsedit} partno={this.props.partno} title={this.props.title} menus={this.props.menus} />}
            {value === 'five' && <BrandImage partsedit={this.props.partsedit} partno={this.props.partno} title={this.props.title} menus={this.props.menus} />}
          </div>
        </Dialog>
      </div>
    );
  }
}

FullScreenDialog.propTypes = { classes: PropTypes.object.isRequired, };

export default withStyles(styles)(FullScreenDialog);
